module.exports = __webpack_public_path__ + "static/media/time-clicked.0714d20a.mp3";